import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import Input from "../../UI/Input";
import Button from "../../UI/Button";
import useInputHandler from "../../Global/Hooks/inputHandler";
import OnboardingModal from "../../Components/Modals/OnboardingModal";
import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import 'react-phone-number-input/style.css';

export default function RegisterDetails() {
  const navigate = useNavigate();
  const accountIndex = useSelector(
      (state) => state.rootReducer.techsbookSlice.userData
  );
  const firstName = useInputHandler();
  const lastName = useInputHandler();
  const companyName = useInputHandler();

  const [phoneValue, setPhoneValue] = useState(accountIndex?.phone || '');

  useEffect(() => {
    if (accountIndex) {
      firstName.setChange(accountIndex.firstname || '');
      lastName.setChange(accountIndex.lastname || '');
      companyName.setChange(accountIndex.company_name || '');
    }
  }, [accountIndex]);

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/register-installations", {
      state: {
        firstname: firstName.value,
        lastname: lastName.value,
        company_name: companyName.value,
        phone: phoneValue,
      },
    });
  };

  const isButtonDisabled =
      !(firstName.value?.length >= 3 &&
          lastName.value?.length >= 3 &&
          companyName.value?.length >= 3 &&
          (phoneValue && isValidPhoneNumber(phoneValue)));  // Ensure phoneValue is truthy

  return (
      <RegisterWrapper image="/assets/images/register-3.svg">
        <div
            className="b-button"
            onClick={async () => {
              localStorage.setItem("techsbook_customer_portal_token", '');
              await navigate('/login');
            }}
        >
        <span>
          <img src="/assets/icons/left-arrow.svg" alt="arrow" />
        </span>
          <span>Log out</span>
        </div>
        {accountIndex?.registration_completed === 0 && <OnboardingModal />}
        <h1 className="register__title mt20">Tell us about yourself</h1>
        <form onSubmit={handleSubmit} className="register__form">
          <div className="register__row mt20">
            <div className="register__input">
              <Input
                  {...firstName}
                  label="First name"
                  placeholder="Enter first name"
                  type="text"
                  id="first_name"
                  value={firstName.value}
              />
            </div>
            <div className="register__input">
              <Input
                  {...lastName}
                  label="Last name"
                  placeholder="Enter last name"
                  type="text"
                  id="last_name"
                  value={lastName.value}
              />
            </div>
          </div>
          <div className="register__input mt20">
            <Input
                {...companyName}
                label="Company name"
                placeholder="Enter company name"
                type="text"
                id="company_name"
                value={companyName.value}
            />
          </div>
          <div className="register__input mt20">
            <div className="input__fill">
              <PhoneInput
                  // country="US"
                  value={phoneValue}
                  onChange={setPhoneValue}
                  className="input__fill-input"
              />
            </div>
          </div>
          <div className="register__btn mt40">
            <Button
                text="Continue"
                type="primary"
                disabled={isButtonDisabled}
                topPadding={12}
                bottomPadding={12}
            />
          </div>
        </form>
      </RegisterWrapper>
  );
}
